export default { PACKAGE_VERSION: "1.17.0" };
